
import * as React from "react";
import { Toast, State, ToasterToast } from "./types";
import { 
  genId, 
  dispatch, 
  memoryState,
  listeners
} from "./toast-reducer";

// Main toast function for creating notifications
export function toast({ ...props }: Toast) {
  // Add debugging to track toast calls
  console.log("Toast called with:", props);
  
  const id = genId();

  // Keep duration undefined by default to disable auto-closing
  const duration = props.duration;

  const update = (props: ToasterToast) =>
    dispatch({
      type: "UPDATE_TOAST",
      toast: { ...props, id },
    });
    
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });

  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      open: true,
      duration: duration,
      onOpenChange: (open) => {
        if (!open) dismiss();
      },
    },
  });

  return {
    id: id,
    dismiss,
    update,
  };
}

// Hook for accessing and controlling toast state
export function useToast() {
  const [state, setState] = React.useState<State>(memoryState);

  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
    toast,
    dismiss: (toastId?: string) => dispatch({ type: "DISMISS_TOAST", toastId }),
  };
}
